import initialState from './initialState'

/**
 * @description
 * Returns state to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

const SET_TICKET_COUNTER = (state, payload) => {
    state.ticketCounter = payload
}
const SET_OFFICE_ID = (state, payload) => {
    state.officeID = payload
}

const SET_INVOICE_TICKET_COUNTER = (state, payload) => {
    state.invoiceTicketCounter = payload
}

export default {
    RESET_STATE,
    SET_TICKET_COUNTER,
    SET_OFFICE_ID,
    SET_INVOICE_TICKET_COUNTER,
}
